import script from "./LoginActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginActivity.vue?vue&type=script&lang=ts&setup=true"

import "./LoginActivity.vue?vue&type=style&index=0&id=227bb9db&lang=scss"

const __exports__ = script;

export default __exports__